module.exports = __webpack_public_path__ + "img/mac.9cf38ad0.svg";